import { Clock } from "./Clock";
import { Cagenomics } from "./FFPunchStats";
import { TeamStat } from "./TeamStat";
import { WalkoutL3RD } from "./WalkoutL3RD";
import { RingL3RD } from "./RingL3RD";
import { FightIdentFF } from "./FightIdentFF";
import { TaleoftheTape } from "./TaleoftheTape";
import { WinnerL3rd } from "./Winnerl3rd";
import { RefL3rd } from "./RefereeName";
import { FFFightCard } from "./FF_Fight_Card";
import { MCName } from "./MCName";
import { Guest } from "./Guest";
import { Judges } from "./Judges";
import { FightIdentClock } from "./FightIdentClock";
import { BottomLeftStatsALT } from "./BottomLeftStats_Alt";
import { SOF_Stats } from "./SOF_Stats";
import { Scorecard } from "./Scorecard";
import { Bug } from "./Bug";
import { Corner } from "./Corner";


export default function graphics({
  takeVizPage: animate,
  update,
  takeOutVizPageTL: animateOff,
  triggerAnimation,
  clearPreview,
  previewTrio: preview,
  getVizPage,
  updateVizPage,
  vizSharedMemory,
  vizCommand
}) {
  return [
    new Clock({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
      vizCommand
    }),
    new Cagenomics({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TeamStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new WalkoutL3RD({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new RingL3RD({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new TaleoftheTape({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FightIdentFF({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new WinnerL3rd({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new RefL3rd({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FFFightCard({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new MCName({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Guest({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Judges({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new FightIdentClock({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new BottomLeftStatsALT({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new SOF_Stats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Scorecard({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Bug({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Corner({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
  ];
}
